import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { UserDetailPage } from './user-detail.page';
import { SharedModule } from './../shared-module/shared.module';
import { UserDetailPageRoutingModule } from './user-detail-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    UserDetailPageRoutingModule
  ],
  declarations: [UserDetailPage]
})
export class UserDetailPageModule {
  slideOpts = {
    initialSlide: 1,
    speed: 400
  };
}
